<template>
  <div>
    <d-row>
      <d-col lg="6">
        <div class="mb-3">
          <h5>Parking</h5>

          <d-alert show>
            <i class="fa fa-info"></i>
            <span>If you enter a zero <strong>(0)</strong> for a product's availability, it means that this product is always available, no matter how many bookings there are for that product.</span>
          </d-alert>

          <d-checkbox class="mb-3" v-model="parking.available" style="margin-bottom: 0; font-weight: 400;">Is this parking available?</d-checkbox>

          <div class="form-group">
            <label for="availability">Total available spots</label>
            <d-input id="availability" v-model="parking.availability" />
          </div>
        </div>

        <!-- <div>
          <h5>Products</h5>

          <template v-for="(service, i) in services">
            <div :key="i">
              <d-row class="mb-3">
                <d-col lg="4" style="display: flex; align-items: center;">
                  <d-checkbox v-model="products[service.id].available" style="margin-bottom: 0; font-weight: 400;">
                    {{service.localizedName}}
                  </d-checkbox>
                </d-col>

                <d-col lg="8">
                  <d-input v-model="products[service.id].availability" placeholder="Total available spots" />
                </d-col>
              </d-row>
            </div>
          </template>
        </div> -->

        <d-button theme="primary" @click="onSubmit">Save Changes</d-button>
      </d-col>
    </d-row>
  </div>
</template>

<script>
export default {
  methods: {
    onSubmit: async function (event) {
      event.preventDefault();

      // Gather the products.
      // const products = [];

      // Object.values(this.products).forEach(product => {
      //   if (product.travelTime === undefined) {
      //     return;
      //   }

      //   products.push({
      //     deliveryAddress: product.deliveryAddress,
      //     maxTravelers: parseInt(product.maxTravelers),
      //     availability: parseInt(product.availability),
      //     travelTime: parseInt(product.travelTime),
      //     terminals: product.terminals,
      //     available: product.available,
      //     serviceID: product.serviceID,
      //     id: product.id,
      //   });
      // });

      const data = await this.$apollo.mutate({
        mutation: require('~/graphql/parkings/UpdateAvailability.gql'),
        variables: {
          id: this.parking.id,
          available: this.parking.available,
          availability: parseInt(this.parking.availability),
          // products: products,
        }
      });

      if (data.data.updateProvider.provider) {
        window.location.reload(true);
      }
    },

    isDirty: () => false,
  },

  apollo: {
    load: function () {
      return {
        fetchPolicy: 'no-cache',
        update: function (data) {
          this.services = data.services;

          data.services.forEach(service => {
            const product = this.parking.products.find(product => product.serviceID === service.id && !product.mobianID.length);

            this.products[service.id] = {
              deliveryAddress: {
                zipCode: (product && product.deliveryAddress.zipCode) || '',
                country: (product && product.deliveryAddress.country) || '',
                street: (product && product.deliveryAddress.street) || '',
                city: (product && product.deliveryAddress.city) || '',
              },
              maxTravelers: (product && product.maxTravelers) || undefined,
              availability: (product && product.availability) || undefined,
              travelTime: (product && product.travelTime) || undefined,
              serviceID: service.id,
              terminals: (product && product.terminals) || [],
              available: (product && product.available) || false,
              id: (product && product.id) || undefined,
            };
          });
        },
        query: require('~/graphql/ParkingsMobian.gql'),
      };
    },
  },

  props: {
    parking: {
      required: true,
      type: Object,
    },
  },

  data: function () {
    return {
      services: [],
      products: {},
    };
  },
};
</script>
